import React, { useMemo } from 'react';

import { AutoComplete, type AutoCompleteProps } from 'antd';
import { useGetModulesQuery } from 'src/redux/services/centralApi';

export default function SelectTeam(
	{
		...props
	}: AutoCompleteProps
) {

	const {
		data,
	} = useGetModulesQuery({});

	const teamOptions = useMemo(() => {
		if(!data) return [];

		const teamList: string[] = [];
		data.forEach(module => {
			if(!teamList.includes(module.team)){
				teamList.push(module.team);
			}
		});

		return teamList.map(team => ({
			value: team,
			label: team,
		}));
	}, [ data, ]);

	return (
		<AutoComplete
			placeholder={'Time'}
			options={teamOptions}
			{...props}
		/>
	);
}
